<ng-container *ngIf="countdown$ | async as countdown">
  {{ countdown | date: 'mm:ss' }}
</ng-container>
